const images = {
  developer: require("./hero-1.webp"),
  hand: require("./waving-hand.webp"),
  c: require("./c.png"),
  html: require("./html-5.webp"),
  css: require("./css-3.webp"),
  sass: require("./sass.webp"),
  js: require("./js.webp"),
  python: require("./python.png"),
  cpp: require("./c-.webp"),
  php: require("./php.webp"),
  sql: require("./mysql.png"),
  mongodb: require("./mongodb.png"),
  github_day: require("./github-day.webp"),
  github_dark: require("./github-dark.webp"),
  bootstrap: require("./bootstrap.webp"),
  tailwind: require("./tailwind.png"),
  react: require("./react.png"),
  wave: require("./wave.webp"),
  contentgen: require("./contentgen.jpg"),
  primemax: require("./primemax.jpg"),
  ham: require("./ham.webp"),
  close: require("./cross.webp"),
  cardio: require("./cardio.jpg"),
  profile: require("./Profile1.jpeg"),
  edu: require("./edu.webp"),
  resume: require("./resume.pdf"),
  aasaansend: require("./aasaansend.jpg"),
  postman: require("./postman.webp"),
  vscode: require("./vsCode.webp"),
  java: require("./java.webp"),
  cursor: require("./feather.png"),
  selenium: require("./selenium.webp"),
  jenkins: require("./jenkins.webp"),
  linux: require("./linux.webp"),
  dotnet: require("./dotnet.png"),
  csharp: require("./csharp.png"),
  sqlserver: require("./sqlserver.png"),
  azure: require("./azure.png"),
  express: require("./express.png"),
  nextjs: require("./nextjs.png"),
  psql: require("./psql.png"),
  docker: require("./docker.png"),
  node: require("./node.png"),
  typescript: require("./typescript.png"),
  vs: require("./vs.png"),
  codersvoice: require("./codersvoice.jpg")
};
export default images;
